// Added by Sejune Oh on 2020-03-02
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react';
import {
    CardActions as MaterialUICardActions,
    CardActionsProps as MaterialUICardActionsProps
} from '@material-ui/core'

interface CardActionsBaseProps { }
export type CardActionsProps = Partial<MaterialUICardActionsProps> & CardActionsBaseProps

export const CardActions: FC<CardActionsProps> = ({ ...props }) => {
    return <MaterialUICardActions {...props}></MaterialUICardActions>
}
